import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import config from "../config";
import ReviewPage from "../Review/Reviewpage";
import { getPendingCount } from "./pendingAnswerService";
import axios from "axios";
import {
  ASSESSMENT_STATUS,
  ASSESSMENT_STATUS_LABELS,
  ASSESSMENT_STATUS_ORDER,
} from "./assessmentStatus";
 

const SubmitExamDialog = ({
  open,
  onClose,
  answeredCount,
  notAnsweredCount,
  markedCount,
   showMarkedForReview,
  isAuto = false,
  autoReason = null,
  examId,             // <-- ADD THIS
  examEmployeeId,
  unansweredMandatoryCount,   // use prop!
  notVisitedCount,
  mongoSavedCount,
  pendingSyncCount,

}) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();

  const statusCounts = {
    [ASSESSMENT_STATUS.NOT_ANSWERED]: notAnsweredCount,
    [ASSESSMENT_STATUS.NOT_VISITED]: notVisitedCount,
    [ASSESSMENT_STATUS.MARKED_FOR_REVIEW]: markedCount,
    [ASSESSMENT_STATUS.ANSWERED_AND_SAVED]: mongoSavedCount,
    [ASSESSMENT_STATUS.ANSWERS_NOT_SAVED]: pendingSyncCount,
  };
 
  const statusIcons = {
    [ASSESSMENT_STATUS.NOT_ANSWERED]: "❌",
    [ASSESSMENT_STATUS.NOT_VISITED]: "🚫",
    [ASSESSMENT_STATUS.MARKED_FOR_REVIEW]: "📌",
    [ASSESSMENT_STATUS.ANSWERED_AND_SAVED]: "🟢",
    [ASSESSMENT_STATUS.ANSWERS_NOT_SAVED]: "🔵",
  };
 
  const renderStatusSummary = () =>
    ASSESSMENT_STATUS_ORDER.map((statusKey) => {
      if (
        statusKey === ASSESSMENT_STATUS.MARKED_FOR_REVIEW &&
        !showMarkedForReview
      ) {
        return null;
      }
 
      return (
        <p key={statusKey}>
          {statusIcons[statusKey]} {ASSESSMENT_STATUS_LABELS[statusKey]}: {statusCounts[statusKey]}
        </p>
      );
    });
 
 

  const exitFullscreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else if (document.webkitFullscreenElement) {
      document.webkitExitFullscreen(); // Safari
    } else if (document.msFullscreenElement) {
      document.msExitFullscreen(); // IE/Edge
    }
  };



  const waitForSave = (maxWaitMs = 3000) =>
    new Promise((resolve) => {
      if (!window.pendingWsSave) {
        resolve();
        return;
      }

      const startedAt = Date.now();
      const check = () => {
        if (!window.pendingWsSave || Date.now() - startedAt >= maxWaitMs) {
          resolve();
        } else {
          setTimeout(check, 100);
        }
      };

      check();
    });

  const safeParseJson = async (response) => {
    const contentType = response.headers.get("content-type") || "";
    if (contentType.includes("application/json")) {
      return response.json();
    }

    const text = await response.text();
    throw new Error(
      `Server returned a non-JSON response (status ${response.status}): ${text.slice(0, 150)}`
    );
  };



  const handleSubmit = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    setSubmitError(null);
    await waitForSave();
    const pending = getPendingCount();

    if (pending && !isAuto) {

      alert(`${pending} answers are still waiting for synchronization.`);

      setIsSubmitting(false);

      return;
    }
    try {

      const response = await axios.post(
        `/exam/submit/`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      const data = response.data;

      if (response.status >= 200 && response.status < 300) {
        sessionStorage.setItem("examCompleted", "true");
        exitFullscreen();
        setShowSuccess(true);
        onClose(); // Close confirmation dialog

      } else {
        console.error("Submission failed:", data);
        // alert("Assessment submission failed!");
        setSubmitError(data?.message || "Assessment submission failed. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting Assessment:", error);
      setSubmitError(error?.message || "Assessment submission failed. Please try again.");
    }
    finally {
      setIsSubmitting(false);
    }
  };



  const handleCloseSuccess = () => {
    setShowSuccess(false);
  };

  useEffect(() => {
    if (open) {
      setSubmitError(null);
      setIsSubmitting(false);
    }
  }, [open]);

  const handleViewResults = () => {
    setShowSuccess(false);
    setShowReviewModal(true);
    setTimeout(() => {
      exitFullscreen();
    }, 0);
    // navigate("/user/dashboard");
  };
  //   useEffect(() => {
  //   if (open) {
  //     handleSubmitClick();   // 🔥 Run mandatory check when dialog becomes visible
  //   }
  // }, [open]);

  useEffect(() => {
    if (open && isAuto) {
      const timer = setTimeout(() => {
        handleSubmit();
      }, 1500);

      return () => clearTimeout(timer);
    }
  }, [open, isAuto]);





  return (
    <>
      {/* ---- Submit Confirmation Dialog ---- */}
      <Dialog
        open={open}
        onClose={isAuto ? undefined : onClose}
        disableEscapeKeyDown={isAuto}
        disableBackdropClick={isAuto} // for older MUI versions, else use `onClose={null}`
      >

        <DialogTitle>
          {isSubmitting ? "Submitting Assessment..." : "Submit Assessment?"}
        </DialogTitle>
        {/* <DialogContent>
          <p>
            Are you sure you want to submit your exam? Once submitted, you
            cannot modify your answers or review questions.
          </p>
          <div className="submit-summary">
            <p>✅ Answered: {answeredCount}</p>
            <p>❌ Not Answered: {notAnsweredCount}</p>
            <p className="mb-0">📌 Marked for Review: {markedCount}</p>
          </div>
          
        </DialogContent> */}
        <DialogContent>
          {submitError && (
            <div style={{
              backgroundColor: "#f8d7da",
              color: "#721c24",
              padding: "10px",
              borderRadius: "4px",
              marginBottom: "15px",
              border: "1px solid #f5c6cb"
            }}>
              ❌ {submitError}
            </div>
          )}
          {isAuto && autoReason === "malpractice" && (
            <p style={{ color: "red", fontWeight: "600" }}>
              Maximum malpractice limit exceeded. Your assessment is being submitted automatically.
            </p>
          )}
          {isAuto && autoReason === "timeout" && (
            <p style={{ color: "orange", fontWeight: "600" }}>
              Time is up! Your assessment is being submitted automatically.
            </p>
          )}
          {isSubmitting && (
            <p style={{ fontWeight: 600 }}>
              Please wait while your latest answers are saved and the assessment is submitted.
            </p>
          )}


          {/* If mandatory not answered → show warning */}
          {unansweredMandatoryCount > 0 ? (
            <>
              <p style={{ color: "red", fontWeight: "600" }}>
                ⚠ You still have {unansweredMandatoryCount} mandatory questions not attempted.
                Are you sure you want to submit?
              </p>

              <div className="submit-summary">
                {renderStatusSummary()}
 
                
                {/* <p>
                  🟢 Answered  : {mongoSavedCount}
                </p>

                <p>
                  🔵 Pending Answers : {pendingSyncCount}
                </p>
                <p>
                  ❌ Not Answered: {notAnsweredCount}
                </p>
                <p> 🚫Not Visited:{notVisitedCount}</p>

                <p className="mb-0">📌 Marked for Review: {markedCount}</p> */}
              </div>
            </>
          ) : (
            <>
              <p>
                Are you sure you want to submit your Assessment? Once submitted, you
                cannot modify your answers or review questions.
              </p>

              <div className="submit-summary">
                {/* <p>✅ Answered: {answeredCount}</p> */}
                 {/* <p>
                  🟢 Answered : {mongoSavedCount}
                </p>

                <p>
                  🔵 Pending Answers : {pendingSyncCount}
                </p>
                <p>
                  ❌ Not Answered: {notAnsweredCount}
                </p>
                <p> 🚫Not Visited:{notVisitedCount}</p>
                <p className="mb-0">📌 Marked for Review: {markedCount}</p> */}
                {renderStatusSummary()}
 
              </div>
            </>
          )}

        </DialogContent>

        {/* <DialogActions className="px-3 pb-3">
          <button className="btn btn-outlineWhite" onClick={onClose}>
            Cancel
          </button>
          <button className="btn BlueBtn" onClick={handleSubmit}>
            Submit Final
          </button>
        </DialogActions> */}

        <DialogActions className="px-3 pb-3">
          {!isAuto && !isSubmitting && (
            <button className="btn-negative" onClick={onClose}>
              Cancel
            </button>
          )}
          <button
            className="btn BlueBtn"
            onClick={handleSubmit}
            disabled={isSubmitting}
            autoFocus
          >
            {isSubmitting ? "Submitting..." : "Submit Final"}
          </button>
        </DialogActions>
      </Dialog>

      {/* ---- Success Modal ---- */}
      {showSuccess && (
        <>
          {/* Masked background */}
          <div
            className="modal-backdrop show"
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1040,
              backdropFilter: "blur(3px)",
            }}
          />

          {/* Success Modal */}
          <div
            className="modal fade show"
            style={{
              display: "block",
              zIndex: 1050,
              overflow: "hidden",
            }}
            tabIndex="-1"
            role="dialog"
          >
            <div
              className="modal-dialog modal-dialog-centered"
              role="document"
              style={{ maxWidth: "500px", margin: "auto" }}
            >
              <div
                className="modal-content"
                style={{
                  borderRadius: "8px",
                  overflow: "hidden",
                  textAlign: "center",
                }}
              >
                <div
                  className="modal-headers text-white"
                  style={{
                    background:
                      "#0191c8",
                    justifyContent: "center",
                    borderBottom: "none",
                    padding: "1rem",

                  }}
                >
                  <h4
                    className="modal-title"
                    style={{ margin: 0, fontSize: "1.25rem" }}
                  >
                    Successfully Submitted
                  </h4>
                </div>

                <div
                  className="modal-body"
                  style={{
                    padding: "20px 30px",
                    fontSize: "1rem",
                    color: "#333",
                    lineHeight: "1.6",
                  }}
                >
                  <p style={{ fontSize: "1rem", padding: "50px" }}>
                    ✅ Your Assessment has been submitted successfully!
                  </p>
                </div>

                {/* <div
                  className="modal-footer"
                  style={{
                    justifyContent: "center",
                    borderTop: "1px solid #eee",
                    padding: "1rem",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-gradient"
                    onClick={handleViewResults}
                    style={{
                      background:
                        "#0191c8",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      padding: "0.6rem 1.3rem",
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                  >
                    View Results
                  </button>
                </div> */}

                <div
                  className="modal-footer"
                  style={{
                    justifyContent: "center",
                    borderTop: "1px solid #eee",
                    padding: "1rem",
                    gap: "10px",
                  }}
                >
                  {/* Close button → Dashboard */}
                  <button
                    type="button"
                    className="btn-negative"
                    onClick={() => {
                      exitFullscreen();
                      navigate("/users/dashboard")
                    }}
                    style={{
                      borderRadius: "4px",
                      padding: "0.6rem 1.3rem",
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                  >
                    Close
                  </button>

                  {/* View Results → Review Page */}
                  <button
                    type="button"
                    className="btn btn-gradient"
                    onClick={handleViewResults}
                    style={{
                      background: "#0191c8",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      padding: "0.6rem 1.3rem",
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                  >
                    View Results
                  </button>

                </div>

              </div>
            </div>
          </div>
        </>
      )}
      {/* ---- Review Modal ---- */}
      <Dialog
        open={showReviewModal}
        onClose={() => {
          setShowReviewModal(false);
          navigate("/users/dashboard");
        }}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle sx={{ fontWeight: "bold", textAlign: "center" }}>
          Assessment Review
        </DialogTitle>

        <DialogContent
          sx={{
            p: 0,
            height: "75vh",
            overflowY: "auto",
          }}
        >
          <ReviewPage examEmployeeId={examEmployeeId} />

        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", p: 2 }}>
          <button
            className="btn btn-outline-secondary"
            onClick={() => {
              setShowReviewModal(false);
              navigate("/users/dashboard");
            }}
          >
            Close
          </button>
        </DialogActions>
      </Dialog>

    </>
  );
};

export default SubmitExamDialog;

